import { httpInstance } from '@/services/httpInstance';

const createFeaturesFlagCommerceService = async (dataParam) => {
  let res;
  const endpoint = '/back-office/v1/features-flag-commerce';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createFeaturesFlagCommerceService;
